// import notification from '../notification';
import { useState, useEffect, } from 'react';
import { useNavigate, useLocation, } from 'react-router';
import { UserStatus, } from '../users';
// import { useIntl, } from "react-intl";
// ;

export const useFetchAuth = ({
    required,
    location,
}) => {

    const history = useNavigate();
    const [loading, setLoading] = useState(true);
    const [subscriptionStatus, setSubscriptionStatus] = useState(false);
    const [auth, setAuth] = useState();
    const { pathname } = useLocation();

    // If license is expired, this paths are allowed:
    const allowed_paths = ["/login", "/profile", "/invoice", "/connection_error", "/dashboard"];

    useEffect(() => {
        // if (!loading && auth) { return; };

        // When the user is not logged in but login is required
        if (required && (auth === undefined)) {
            UserStatus(history)
                .then(response => {
                    setSubscriptionStatus(response.data.subscription_status);
                    if (response.status && response?.data.authenticated) {
                        setLoading(false);
                        setAuth(response.data);
                    } else {
                        setLoading(false);
                        if (response?.data.permission === "users") {
                            alert("You are not authorized to access this page.");
                        }
                        // Session expired or not authenticated — always redirect to login
                        // when this layout requires authentication.
                        if (required) {
                            history('/login');
                        }
                    };
                })
                .catch(error => {
                    switch (error?.status) {
                        case 401:
                        case 403:
                            history('/login');
                            break;
                        default:
                            // `error` is the axios response object (api.js rejects with
                            // error.response). When there is no HTTP response at all
                            // (network outage, DNS failure, CORS) error.response is
                            // undefined, so `error` here is nullish → true connection
                            // problem → show connection_error.
                            // When the server DID respond (e.g. 422, 500) but with an
                            // unexpected status, the session/token is the likely cause
                            // → redirect to login instead.
                            history(error ? '/login' : '/connection_error');
                            break;
                    }

                    setLoading(false);
                });
        } else {
            // authorisation is not needed, remove loading
            setLoading(false);
            return;
        }

        return () => { }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        // check only if license has not been valid
        if (!subscriptionStatus && !loading) {

            // check if the current path is allowed
            const startsWithAllowedPath = allowed_paths.some(path => pathname.startsWith(path));

            // Only allow "license free" paths.
            if (!startsWithAllowedPath && pathname !== "/") {
                // subscription is invalid and the current path is not allowed
                // notification['error']({
                //     message: 'License error',
                //     description: intl.formatMessage({ id: "LICENSE_EXPIRED_INVALID" }),
                // });
                history("/dashboard");
            }
        }

        return () => { }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, loading]);

    return { auth, loading };
};
